import { Tooltip } from '@cinesend/ui-kit'
import { ArrowsClockwise } from '@phosphor-icons/react'

const CycleIsValidatingTag = ({ is_validating = false }) => {
  if (!is_validating) return null

  return (
    <Tooltip
      side='bottom'
      align='start'
      title='Checking every asset in this cycle against its validators.'
      trigger={
        <button
          type='button'
          aria-label='Validating'
          className='inline-flex align-middle border-0 bg-transparent p-0 text-gray-400'
        >
          <ArrowsClockwise size={18} weight='bold' className='animate-spin cs-sync-spin' aria-hidden='true' />
        </button>
      }
    />
  )
}

export default CycleIsValidatingTag
